export default "__VITE_ASSET__Ds73i3Uo__"